import React, { Children } from "react";
import CustomToastUi from "../CustomToast/CustomToastUi";
import CustomToast from "../CustomToast/CustomToast";

function FormUi({ children, formik, submitDisplayNone, gridNot, toast }) {
  return (
    <>
      {/* Main Content */}
      <section className={`${gridNot ? "" : "content"}`}>
        <div className="row">
          <div className="col-md-12 m-auto">
            <div className="card card-primary">
              <div className="container-fluid">
                <div className="mt-3">
                  {toast && (
                    <CustomToast text={toast?.message} type={toast?.type} />
                  )}
                   </div>
                  <form onSubmit={formik.handleSubmit} autoComplete='off'>
                    <div className={` card-body ${gridNot ? "" : "form-grid"}`}>
                      {children}
                    </div>
                    {submitDisplayNone ? (
                      ""
                    ) : (
                      <div className="card-footer d-flex justify-content-end">
                        <button type="submit" className="blue-btn">
                          {/* {formik?.dirty ? (
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )} */}
                          Submit
                        </button>
                      </div>
                    )}
                  </form>
               
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FormUi;
